const mobile = (value?: number) => {
  if (value !== undefined) return value < 768;
  return window.innerWidth < 768;
};

export default mobile;
